<template>
    <section class="showcase">
    <div class="p-0">
        <div class="col-lg-12 order-lg-1 my-auto showcase-text">
          <h3>SUKIMATCHとは</h3>
          <h1 class="lead mb-0">どんなサービス?</h1>
        </div>

      <div class="row no-gutters">
         <!-- Heading Row -->
    <div class="row align-items-center test">
      <div class="col-lg-6">
        <img class="img-fluid explan-img" src="../assets/img/sukimatch/explain1.jpg" alt="">
      </div>
      <!-- /.col-lg-8 -->
      <div class="col-lg-6">
        <h1 class="font-weight-light">バナー制作の困りごとをお手伝いします</h1>
        <p class="sk-p-text">SUKIMATCHはバナー制作に特化したスキルマッチングサービスです。様々な得意ジャンルを持つクリエイターたちが、バナー作成で手が足りない、ちょっとだけ手伝って欲しいとお困りのあなたをサポートいたします。</p>
    
      </div>
      <!-- /.col-md-4 -->
    </div>
      </div>
    <!-- /.row -->
         <!-- Heading Row -->
         <div class="row no-gutters">
    <div class="row align-items-center test">
      <div class="col-lg-6">
        <img class="img-fluid explan-img" src="../assets/img/sukimatch/explain2.jpg" alt="">
      </div>
      <!-- /.col-lg-8 -->
      <div class="col-lg-6">
        <h1 class="font-weight-light">希望に合うクリエイターに出会えます</h1>
        <p class="sk-p-text">急なご依頼や大量作成など、制作担当者さんのお困りに合わせたクリエイターが見つかります。フィードバックを返すことでクリエイターも成長し、さらに”希望にマッチする”サー
ビスをご提供いたします。</p>
      </div>
      <!-- /.col-md-4 -->
    </div>
         </div>


    <div class="row no-gutters">
    <div class="row align-items-center test">
      <div class="col-lg-6">
        <img class="img-fluid explan-img" src="../assets/img/sukimatch/explain3.jpg" alt="">
      </div>
      <!-- /.col-lg-8 -->
      <div class="col-lg-6">
        <h1 class="font-weight-light">バナー1件あたり500円から依頼が可能です</h1>
        <p class="sk-p-text">アウトソーシングにコストの問題はつきものです。SUKIMACHはバナー作成がワンコインから出品されています。もちろん大量発注でまとまった金額でのご相談や、月額制などクリエイターと直接ご相談いただけます。</p>
        
      </div>
      <!-- /.col-md-4 -->
    </div>
    </div>
    
    <!-- /.row -->
      </div>
  </section>
</template>

<script>
export default {
    
}
</script>

<style>
.test {
    margin: 20px;
    color: #f29211;
}

h1 {
    margin-top: 10px;
}

.sk-p-text {
    color: #000000;
    margin-top: 20px;
}

.explan-img {
    width: 70%;
    height: 70%
}

</style>